import { render, staticRenderFns } from "./ArticleSearchView.vue?vue&type=template&id=57ff8c13"
import script from "./ArticleSearchView.vue?vue&type=script&lang=js"
export * from "./ArticleSearchView.vue?vue&type=script&lang=js"
import style0 from "./ArticleSearchView.vue?vue&type=style&index=0&id=57ff8c13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports